/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { track } from '../../analytics';

const EducationalInfo = ({
  link = null, title, shortDescription, multiView = false
}) => {
  const spacingClass = classNames({
    'sui-my-1': multiView,
    'sui-my-4': !multiView
  });

  const renderLink = () => {
    if (!link || (!link.text && !link.url)) return null;
    const { url = '/', text = '' } = link;
    return (
      <div className={spacingClass}>
        <Link href={url} onClick={() => track({ location: 'link', text })}>{text}</Link>
      </div>
    );
  };

  return (
    <div className="sui-flex sui-items-center sui-mt-2 sm:sui-mt-0" data-testid="educational-info">
      <div className="sui-flex sui-flex-col" data-testid={multiView ? 'educational-info-multi-view' : 'educational-info-desktop'}>
        <Typography variant="body-base" weight="bold" className={spacingClass}>
          {title}
        </Typography>
        <Typography variant="body-base" className={spacingClass}>
          {shortDescription}
        </Typography>
        {link && renderLink()}
      </div>
    </div>
  );
};

EducationalInfo.propTypes = {
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }),
  shortDescription: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  multiView: PropTypes.bool
};

export { EducationalInfo };
